(function () {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function money(cents) {
    const format = window.themeMoneyFormat || "${{amount}}";
    const value = (Number(cents) / 100).toFixed(2);
    const parts = value.split(".");
    const withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let out = format.replace(/\{\{\s*amount\s*\}\}/, withComma + "." + parts[1]);
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma);
    return out;
  }

  function updateQtyLabel(select, label) {
    if (!select || !label) return;
    const text = select.options[select.selectedIndex]?.text || "";
    if (/hour/i.test(text)) label.textContent = "Hours";
    else if (/day/i.test(text)) label.textContent = "Days";
    else label.textContent = "Quantity";
  }

  const navToggle = qs("[data-nav-toggle]");
  const mobileNav = qs("[data-mobile-nav]");
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", () => {
      const open = mobileNav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  const drawer = qs("[data-cart-drawer]");
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }
  qsa("[data-cart-open]").forEach((el) => el.addEventListener("click", openDrawer));
  qsa("[data-cart-close]").forEach((el) => el.addEventListener("click", closeDrawer));

  function renderDrawer(cart) {
    if (!drawer) return;
    const body = qs("[data-cart-body]", drawer);
    const countEls = qsa("[data-cart-count]");
    const subtotal = qs("[data-cart-subtotal]", drawer);
    countEls.forEach((el) => {
      el.textContent = String(cart.item_count || "");
      el.hidden = !cart.item_count;
    });
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<p class="lede" style="margin-top:0">Empty. Book a rate from the menu, or inquire for a custom plan.</p>';
      return;
    }
    body.innerHTML = cart.items
      .map((item) => {
        const img = item.image
          ? `<img src="${item.image}" alt="">`
          : `<div style="width:5rem;height:5rem;background:var(--ink-3);border-radius:0.5rem"></div>`;
        return `<div class="drawer-line">
          ${img}
          <div>
            <p style="font-family:var(--font-display);font-size:1.25rem">${item.product_title}</p>
            <p style="color:var(--mist);font-size:0.875rem;margin-top:0.25rem">${item.variant_title || ""}</p>
            <p style="font-size:0.875rem;margin-top:0.5rem">${item.quantity} × ${money(item.final_price)}</p>
          </div>
        </div>`;
      })
      .join("");
  }

  function refreshCart() {
    return fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        renderDrawer(cart);
        return cart;
      });
  }

  qsa("[data-product-form]").forEach((form) => {
    const select = qs("[data-variant-select]", form);
    const qtyLabel = qs("[data-qty-label]", form);
    const price = qs("[data-product-price]");
    updateQtyLabel(select, qtyLabel);
    if (select) {
      select.addEventListener("change", () => {
        updateQtyLabel(select, qtyLabel);
        const opt = select.options[select.selectedIndex];
        if (price && opt && opt.dataset.price) price.innerHTML = opt.dataset.price;
      });
    }
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const data = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: data })
        .then((r) => {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(() => refreshCart())
        .then(() => openDrawer())
        .catch(() => {
          form.submit();
        });
    });
  });

  if (drawer) refreshCart();
})();
